var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('iframe',{attrs:{"src":_vm.url,"sandbox":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }